import { SetStateAction, useContext } from 'react'
import { MultiSelectFilter as UDSMultiSelectFilter } from '@telus-uds/components-web'
import { articleConsumer } from '@/blogBuilder/provider/ArticleProvider'
import frenchMapping from '@/blogBuilder/utils/frenchMapping'

type Props = {
  items: string[]
  lang: string
  label: string
  subtitle?: string
}

const MultiSelectFilter = ({ label, subtitle, items, lang }: Props) => {
  const { selectedTags, setSelectedTags, setCurrentPage } = useContext(articleConsumer)

  if (!items.length) return null

  const multiSelectedItems = items.map((tag) => {
    if (lang === 'fr') {
      return { label: frenchMapping[tag], id: tag }
    }
    return { label: tag, id: tag }
  })

  const handleChange = (state: SetStateAction<string[]>) => {
    setCurrentPage(0)
    setSelectedTags(state)
  }

  return (
    <UDSMultiSelectFilter
      onChange={handleChange}
      values={selectedTags}
      label={label}
      subtitle={subtitle}
      items={multiSelectedItems}
    />
  )
}

export default MultiSelectFilter
